import { WFAxios } from '@api/api.instance';
import { removeEmptyProps } from '@biznessforce/ui-lib';
import { Leave, LeaveRecsQuery } from './leaves.model';
import { CancelToken } from 'axios';
import { handleDateToBackend } from '@constants/dateFormat-utils';

const constructParam = (payload: LeaveRecsQuery) => ({
  searchText: payload.filter ? payload.filter.toLowerCase() : null,
  sort:
    payload?.sortField && payload?.sortField !== 'none'
      ? `${payload?.sortField},${payload?.sortOrder?.toUpperCase()}`
      : null,
  fromDt: payload.fromDt ? handleDateToBackend(payload.fromDt) : null,
  toDt: payload.toDt ? handleDateToBackend(payload.toDt) : null,
  page: payload.pageNumber!.toString(),
  size: payload.pageSize!.toString(),
  lvTypeUuid: payload.lvTypeUuid?.length ? payload.lvTypeUuid.join(',') : null,

  // validity: payload.validity?.key !== "none" ? payload.validity?.key : null,
  status: payload.status || null,
  empId: payload.empId,
  empUuid: payload.empUuid,
});

const WORKFORCE_LEAVE_BASE_URL: string = `${import.meta.env.VITE_BASE_URL_LEAVES}/api`;

export const getLeaveRecords = (query: LeaveRecsQuery) => {
  const params: LeaveRecsQuery = removeEmptyProps(constructParam(query));
  return WFAxios.get<Leave[]>(`${WORKFORCE_LEAVE_BASE_URL}/leaverecs`, {
    params: removeEmptyProps(params),
  });
};

export const getLeaveDetail = (leaveId: string) =>
  WFAxios.get<Leave>(`${WORKFORCE_LEAVE_BASE_URL}/emp/leave`, {
    params: { lvRecUuid: leaveId },
  });

export const applyLeave = (payload: Leave) =>
  WFAxios.post<Leave>(`${WORKFORCE_LEAVE_BASE_URL}/emp/leave`, removeEmptyProps(payload));

export const updateLeave = (payload: Leave) =>
  WFAxios.put<Leave>(`${WORKFORCE_LEAVE_BASE_URL}/emp/leave`, removeEmptyProps(payload));

export const deleteLeave = (leaveId: string) =>
  WFAxios.delete(`${WORKFORCE_LEAVE_BASE_URL}/emp/leave`, {
    params: { lvRecUuid: leaveId },
  });

export const getLeaveTypes = () =>
  WFAxios.get<{ code: string; lvTypeUuid: string; name: string }[]>(
    `${WORKFORCE_LEAVE_BASE_URL}/cfg/currlvtypes`
  );

export const getLeaveCalendar = ({
  empIds,
  fromDt,
  toDt,
}: {
  empIds: string[];
  fromDt?: string;
  toDt?: string;
}) =>
  WFAxios.post<
    {
      empId: string;
      empName: string;
      cells: {
        cellDt: string;
        leave: Leave | null;
      }[];
    }[]
  >(`${WORKFORCE_LEAVE_BASE_URL}/leavecal`, removeEmptyProps({ empUuids: empIds }), {
    params: removeEmptyProps({
      fromDt: handleDateToBackend(fromDt),
      toDt: handleDateToBackend(toDt),
    }),
  });

export const getEmployeeLeaveByDt = ({
  fromDt,
  toDt,
  inclPhoto,
  exclCat,
  cat,
}: {
  fromDt?: string;
  toDt?: string;
  inclPhoto?: boolean;
  exclCat?: string;
  cat?: string;
}) =>
  WFAxios.get(`${WORKFORCE_LEAVE_BASE_URL}/leaverecs`, {
    params: removeEmptyProps({
      fromDt,
      toDt,
      inclPhoto,
      exclCat,
      cat,
    }),
  });

export const fetchHolidaysAPI = (fromDt: string, toDt: string, cancelToken?: CancelToken) =>
  WFAxios.get(`${WORKFORCE_LEAVE_BASE_URL}/holidays/period`, {
    params: {
      fromDt: handleDateToBackend(fromDt),
      toDt: handleDateToBackend(toDt),
    },
    cancelToken,
  });

//Holiday Management
export const getAllHolidaysByYear = (year) => {
  return WFAxios.get(`${WORKFORCE_LEAVE_BASE_URL}/holidays/period?year=${year}`);
};
